import { render, staticRenderFns } from "./watchlist.vue?vue&type=template&id=a90c1946&scoped=true"
import script from "./watchlist.vue?vue&type=script&lang=js"
export * from "./watchlist.vue?vue&type=script&lang=js"
import style0 from "./watchlist.vue?vue&type=style&index=0&id=a90c1946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90c1946",
  null
  
)

export default component.exports